import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import Review from '~/components/molecules/Editorial/Review/Review.vue';
import { SELF_TARGET } from '~/const/button';
var Cta = () => import('~/components/atoms/Cta.vue');
export default {
  name: 'ReviewsGrid',
  components: {
    RegularTitle,
    Review,
    Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _this$payload$primary, _this$payload, _this$payload$primary2, _this$payload$primary3, _this$payload$primary4, _this$payload$primary5, _this$payload$primary6, _this$payload$primary7;
      return {
        title: (_this$payload$primary = (_this$payload = this.payload) === null || _this$payload === void 0 ? void 0 : (_this$payload$primary2 = _this$payload.primary) === null || _this$payload$primary2 === void 0 ? void 0 : _this$payload$primary2.title) !== null && _this$payload$primary !== void 0 ? _this$payload$primary : [],
        reviews: this.payload.items.map(item => {
          var _item$stars, _item$review_user, _item$review_experien, _item$review_descript;
          return {
            stars: (_item$stars = item.stars) !== null && _item$stars !== void 0 ? _item$stars : 0,
            review_user: (_item$review_user = item.review_user) !== null && _item$review_user !== void 0 ? _item$review_user : {},
            review_experience: (_item$review_experien = item.review_experience) !== null && _item$review_experien !== void 0 ? _item$review_experien : '',
            review_description: (_item$review_descript = item.review_description[0].text) !== null && _item$review_descript !== void 0 ? _item$review_descript : ''
          };
        }),
        button: {
          cta: (_this$payload$primary3 = this.payload.primary.cta) !== null && _this$payload$primary3 !== void 0 ? _this$payload$primary3 : '',
          url: (_this$payload$primary4 = this.payload.primary.url.url) !== null && _this$payload$primary4 !== void 0 ? _this$payload$primary4 : '',
          tracking: {
            data: {
              event_category: (_this$payload$primary5 = this.payload.primary.event_category1) !== null && _this$payload$primary5 !== void 0 ? _this$payload$primary5 : '',
              event_action: (_this$payload$primary6 = this.payload.primary.event_action1) !== null && _this$payload$primary6 !== void 0 ? _this$payload$primary6 : '',
              event_label: (_this$payload$primary7 = this.payload.primary.event_label1) !== null && _this$payload$primary7 !== void 0 ? _this$payload$primary7 : ''
            }
          }
        }
      };
    },
    target() {
      return SELF_TARGET;
    }
  }
};